<template>
  <div class="opening-times">
    <table
      v-if="weekWorkingTime && showDetails"
      class="ot-table"
    >
      <template v-for="(day, dayIndex) in weekWorkingTime">
        <template v-if="day.workingTime?.length">
          <tr
            v-for="(time, timeIndex) in day.workingTime"
            :key="`${dayIndex} - ${timeIndex}`"
            :class="{ 'ot-row--margin-top': dayIndex !== 0 && timeIndex === 0 }"
          >
            <td>{{ timeIndex === 0 ? day.dayOfWeek : '' }}</td>
            <td>{{ `${time.start} - ${time.end}` }}</td>
          </tr>
        </template>

        <tr
          v-else-if="!hideClosedDays"
          :key="dayIndex"
          class="ot-row--margin-top"
        >
          <td>{{ day.dayOfWeek }}</td>
          <td>{{ $t('store.openingHours.closed') }}</td>
        </tr>
      </template>
    </table>

    <div
      class="ot-toggler"
      @click="showDetails = !showDetails"
    >
      <span class="ot-details">{{ $t('store.openingHours.title') }}</span>
      <fn-icon :icon="showDetails ? 'arrow-up' : 'arrow-down'" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    weekWorkingTime: {
      type: Array,
      required: true,
    },
    hideClosedDays: {
      type: Boolean,
    },
  },
  data() {
    return {
      showDetails: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.opening-times {
  margin-bottom: $pad;
  font-size: map-get($font-sizes, 'l');
}

.ot-table {
  border-collapse: collapse;
  margin-bottom: $pad * 0.5;

  tr td:nth-child(2) {
    padding: 0 0 0 $pad * 0.25;
  }
}

.ot-row--margin-top {
  border-top: math.div($pad, 2) solid transparent;
}

.ot-toggler {
  display: flex;
  gap: math.div($pad, 3);
  align-items: center;
  cursor: pointer;
  margin-left: auto;
  color: $color-action-text-primary-default-base;

  .ot-details {
    text-decoration: underline;
  }
}
</style>
